import React, { useContext } from "react";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import { GlobalContext } from "../../Utils/Contexts";
import { MaybeExtended } from "../../Utils/TypeExtensions";
import { useQuery } from "@apollo/client";
import { getParentAircraftTypes } from "../../GQL/queries";
import { AircraftType } from "../../Generated/avroGraphqlDuty";
import { ObjectUtils } from "../../Utils/ObjectUtils";
import { State } from "../../PilotDuty/PilotDutyPage";

interface Props {
    sourceProperty: string;
    initialValue: MaybeExtended<boolean> | MaybeExtended<number> | undefined;
    labelText: string;
    isRequired: boolean;
    payloadProperty: string;
    localState: State;
    dutyItemId: number;
    setLocalState(arg0: State): void;
    onBlurSelects(): void;
}

export default function AircraftTypeSelector(props: Props): JSX.Element {
    const { data: parentAircraftTypesDbResult } = useQuery(getParentAircraftTypes);

    const context = useContext(GlobalContext);

    const handleOnChange = (e: React.SyntheticEvent, value: string | AircraftType | null): void => {
        if (value) {
            const newPilotDutyItemsList = props.localState.PilotDuty?.DutyItems?.map((l) =>
                l && l.id === props.dutyItemId ? { ...l, AircraftType: value as AircraftType, aircraft_type_id: (value as AircraftType).id } : l,
            );
            props.setLocalState({ ...props.localState, HasChanges: true, PilotDuty: { ...props.localState.PilotDuty, DutyItems: newPilotDutyItemsList } });
        }
    };

    let initialValue: AircraftType | undefined;
    let sortedByName = [] as AircraftType[];

    if (parentAircraftTypesDbResult) {
        const rawList = parentAircraftTypesDbResult.getParentAircraftTypes.slice() as AircraftType[];
        const aircraftTypeListToPresent: AircraftType[] = ObjectUtils.convertToUppercase(rawList.map((aircraftType) => aircraftType));

        sortedByName = aircraftTypeListToPresent
            .sort((a: AircraftType, b: AircraftType) => {
                const acTypeCompare = (a.sort_order ?? 0) - (b.sort_order ?? 0);
                return acTypeCompare === 0 ? (a.name ?? "").localeCompare(b.name ?? "") : acTypeCompare; // sort by type, then name
            })
            .filter((a: AircraftType) => a.name);

        initialValue = aircraftTypeListToPresent.find((p: AircraftType) => p.id === props.initialValue);
    }

    return (
        <>
            <Autocomplete
                value={initialValue === undefined ? null : initialValue}
                options={sortedByName}
                onChange={handleOnChange}
                onBlur={props.onBlurSelects}
                filterSelectedOptions
                renderInput={(params) => <TextField required={props.isRequired} {...params} label={props.labelText} placeholder="type to search" />}
            />
        </>
    );
}
